import { TabsMenu } from '@folio/components';
import { Outlet } from 'react-router-dom';
import { SuspenseLoader } from './ApplicationLayout/SuspenseLoader';
import { Stack } from '@folio/components/ui/flex';

interface PolicyLayoutProps {
  header: React.ReactNode;
  tabs: {
    label: string;
    href: string;
  }[];
}

export function PolicyLayout({ header, tabs }: PolicyLayoutProps) {
  return (
    <Stack>
      {header}
      <TabsMenu tabs={tabs} />
      <SuspenseLoader>
        <Outlet />
      </SuspenseLoader>
    </Stack>
  );
}
